import * as React from 'react'
import { useMemo } from 'react'
import cn from 'classnames'
import { LYSCard, LYSTypography } from '@core/components/Primitives'
import { AttachmentItem } from '@core/components/ProductDetail/Attachments/AttachmentItem'
import { useTranslation } from '@core/i18n/i18n'
import { useProductDetailContext } from '@core/utils/models/product/ProductContext'
import { RenderProp, Slot, template } from '@core/utils/templates'
import style from './index.module.less'

export interface AttachmentsSlots {
  headline: RenderProp<void>
  list: RenderProp<void>
}

export interface AttachmentsComponents {
  AttachmentItem: typeof AttachmentItem
}

export interface AttachmentsProps {
  className?: string
}

const Attachments = template<
  AttachmentsProps,
  AttachmentsSlots,
  AttachmentsComponents
>((props) => {
  const { className, slots, getComponents } = props
  const { t } = useTranslation()
  const { product, variant } = useProductDetailContext() || {}
  const attachments = useMemo(() => {
    return [...(product?.attachments || []), ...(variant?.attachments || [])]
  }, [product, variant])

  if (attachments.length === 0) {
    return null
  }

  const components = getComponents({
    AttachmentItem,
  })

  return (
    <LYSCard
      bordered={false}
      className={cn(style.attachmentSection, className)}
    >
      <Slot render={slots?.headline}>
        <LYSTypography.Text visualAppearance={'h4'}>
          {t('productDetail.attachmentHeading')}
        </LYSTypography.Text>
      </Slot>
      <Slot render={slots?.list}>
        {attachments.map((attachment) => (
          <components.AttachmentItem
            key={attachment.id}
            attachment={attachment}
            className={style.attachmentItem}
          />
        ))}
      </Slot>
    </LYSCard>
  )
})

export default Attachments
